module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAAAXNSR0IArs4c6QAAACdJREFUKFNjZCACMILUfDDS/I9LLSPD/4YRoOijkUY9riBg+s9wAACTEh4bXhuupQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/mobile/aboutUs/h2-2.png
// module id = Fz6b
// module chunks = 1